import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { projects as vendorProjects } from 'features/vendor/projects/projects.i18n'
import { transactionDetailI18n } from 'features/project-details/transaction-details/transaction-details.i18n'
import { vendor_manager } from 'features/vendor-manager/vendor-manager.i18n'
import { workOrder } from 'features/work-order/workOrder.i18n'
import { transaction } from 'features/project-details/transactions/transactions.i18n'
import { projects } from 'features/projects/projects.i18n'
import { userManagementTranslation } from 'features/user-management/user-management.i8n'
import { project } from 'features/update-project-details/project-details.i18n'
import { fpmCards } from 'features/fpm/fpmCards.i18n'
import { clients } from 'features/clients/clients.i18n'
import { accounts } from 'pages/accounts.i18n'
import { sideNav } from '../components/layout/sideNav.i18n'
import { dashboard } from '../features/vendor/dashboard/dashboard.i18n'
import { adminDashboard } from 'features/admin-dashboard/admin-dashboard.i18n'
import { projectType } from '../features/project-type/project-type.i18n'
import { auditLogs } from 'features/project-details/audit-logs/auditLogs.i18n'
import { support } from 'features/support/support.i18n'
import { vendorProfile } from 'features/vendor-profile/vendor-profile.i18n'
import { projectAwards } from 'features/work-order/project-award/projectAward.i18n'
import { globalErrors } from './errors.i18n'
import { performance } from 'features/performance/performance.i18n'

import { property } from 'features/property/property.i18n'
import { new_property } from 'features/property/property.i18n'

import { estimate } from 'features/work-order-estimates/estimate.i18n'

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        //GLOBAL ERRORS
        EXPECTED_AND_COMPLETION_1_YEAR_ERROR:
          'Expected Completion Date cannot be more than 1 year of Expected Start Date',
        ...new_property.en.translation,
        ...vendorProjects.en.translation,
        ...transactionDetailI18n.en.tranlation,
        ...vendor_manager.en.translation,
        ...workOrder.en.translation,
        ...transaction.en.translation,
        ...projects.en.translation,
        ...userManagementTranslation.en.translation,
        ...project.en.translation,
        ...fpmCards.en.translation,
        ...clients.en.translation,
        ...accounts.en.translation,
        ...sideNav.en.translation,
        ...dashboard.en.translation,
        ...adminDashboard.en.translation,
        ...projectType.en.translation,
        ...auditLogs.en.translation,
        ...support.en.translation,
        ...vendorProfile.en.translation,
        ...projectAwards.en.translation,
        ...globalErrors.en.translation,
        ...performance.en.translation,

        ...property.en.translation,

        ...estimate.en.translation,

        // DASHBOARDa
        vendorScore: 'Vendor Score',
        vendorStatus: 'Vendor Status',
        upcomingPayment: 'Upcoming Payment',
        outOf: 'out of',
        licenseExpiration: 'License Expiration',
        insuranceExpiration: 'Insurance Expiration',
        agreementSigned: 'Agreement Signed',
        autoInsurance: 'Auto Insurance',
        errorWarning: 'You do not have any',
        projectSummary: 'Project Summary',
        activeWO: 'Active WO',
        pastDue: 'Past Due WO',
        completedInvoiced: 'Invoiced WO',
        projectManager: 'FPM',
        generalLabourName: 'General Labor',
        projectStatus: 'Status',
        clientStartDate: 'Client Start Date',
        clientDueDate: 'Client Due Date',
        invoicedWO: 'Invoiced WO',
        completednotPaid: 'Rejected Invoices',
        upcomingPayments: 'Upcoming Pay',
        overview: 'Overview',
        WOpaid: 'WO Paid',
        paid: 'Paid',
        active: 'Active',
        paidSmall: 'Paid',
        January: 'January',
        Februray: 'Februray',
        March: 'March',
        April: 'April',
        May: 'May',
        June: 'June',
        July: 'July',
        August: 'August',
        September: 'September',
        October: 'October',
        November: 'November',
        December: 'December',
        export: 'Export',
        setting: 'Setting',
        electrical: 'Electrical',
        plumbing: 'Plumbing',
        generalContractor: 'General Contractor',
        roofing: 'Roofing',
        architecture: 'Architecture',
        mechanical: 'Mechanical',
        noDataDisplayed: 'No data returned for this view.',

        // PROJECTS
        projectsHeading: 'Projects',
        columnSettings: 'Column Settings',
        completed: 'Completed',
        pendingTransaction: 'Pending Transaction',
        pastDueWO: 'Past Due WO',
        type: 'Type',
        status: 'Status',
        newVendor: 'New Vendor',
        vendorDetail: 'Vendor Details',
        transactionStatus: 'Transaction Status',
        WOstatus: 'WO Status',
        address: 'Address',
        region: 'Region',
        pendingTransactions: 'Pending Transactions',
        expectedPaymentDate: 'Expected Payment Date',
        generalLabor: 'General Labor',
        materialCost: 'Material Cost',
        drawAmount: 'Draw Amount',
        flag: 'Flag',

        // Receivable
        dueProjects: 'Due Projects',
        client: 'Client',
        terms: 'Terms',
        paymentTypes: 'Payment Types',
        ticketStatus: 'Ticket Status',
        balance: 'Balance',
        woInvoiceDate: 'WO Invoice Date',
        poNo: 'PO No',
        woNo: 'WO No',
        ticketId: 'Ticket ID',
        markets: 'Markets',
        marketName: 'Markets',
        checkbox: 'Checkbox',
        clearFilter: 'Clear Filter',

        // Payable
        propertyAddress: 'Property Address',
        managerSpecialistName: 'Maintenance Specialist',
        vendorAddress: 'Vendor Address',
        wOCompletedDate: 'WO Completed Date',
        wOIssueDate: 'WO Issue Date',
        id: 'ID',
        woStartDate: 'WO Start Date',

        //  Projects - Table Setting Columns
        ProjectLabel: 'Type',
        vendorWOStatusValue: 'WO Status',
        transactionTypeLabel: 'Type',
        parentWorkOrderId: 'Vendor',
        transactionTotal: 'Total Amount',
        modifiedDate: 'Submit',
        skillName: 'Trade',
        pastDueWorkorders: 'Past Due WO',
        vendorWOExpectedPaymentDate: 'Expected Payment Date',

        // Projects-Transactions
        newTransaction: 'New Transaction',
        newWorkOrder: 'New Work Order',
        newDocument: 'New Document',
        newAlert: 'New Alert',
        editAlert: 'Edit Alert',
        transaction: 'Transactions',
        projectDetails: 'Project Details',
        vendorWorkOrders: 'Vendor Work Orders',
        documents: 'Documents',
        alerts: 'Alerts',
        upload: 'Upload',
        uploadDocument: 'Upload Document',
        contactName: 'Contact Name',
        projectID: 'Project ID',
        WoID: 'WO ID',
        contactNo: 'Contact No',
        WODueDate: 'WO Due Date',
        dueDateWO: 'Due Date WO',
        trade: 'Trade',
        auditLogs: 'Audit Logs',
        totalAmount: 'Total Amount',
        submit: 'Submit',
        approvedBy: 'Approved By',
        paymentType: 'Payment Type',
        transactionType: 'Transaction Type',
        against: 'Against',
        changeOrder: 'Change Order',
        workOrder: 'Work Order',
        paymentTerm: 'Payment Term',
        newExpectedCompletionDate: 'New Expected Completion',
        paymentReceivedDate: 'Payment Received',
        paidDate: 'Paid Date',
        paidDateVariance: 'Paid Date Variance',
        addNewRow: 'Add New Row',
        newRow: 'New Row',
        rejectedInvoiceInfo: 'Rejected Invoice Info',
        deleteRow: 'Delete Row',
        attachment: 'Attachment',
        invoiceGenerateMsg: 'Are you sure you want to generate invoice?',
        dateCreated: 'Date Created',
        contact: 'Contact',
        dateModified: 'Date Modified',
        modifiedBy: 'Modified By',
        description: 'Description',
        amount: 'Amount',
        total: 'Total',
        close: 'Close',
        save: 'Save',
        finalSOW: 'Final SOW',
        accountpayable: 'Account Payable',
        projectcost: 'Project Cost',
        revenue: 'Revenue',
        profits: 'Profits',
        profitmargins: 'Profit Margins',

        // Projects-WorkOrderDetails
        editVendorWorkOrder: 'Edit Vendor Work Order',
        workOrderDetails: 'Work Order Details',
        projectAward: 'Project Award',
        companyName: 'Company Name',
        ownerName: 'Primary Contact',
        clientApprovedAmount: 'Client Approved Amount',
        profitPercentage: 'Profit Percentage',
        vendorWorkOrderAmount: 'Vendor WO Amount',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        issue: 'Issue',
        lienWaiver: 'Lien Waiver',
        estimates: 'Estimates',
        lienWaiverRejectInfo: 'has made changes, you are required to generate LW again.',
        rejectLienWaiver: 'Reject Lien Waiver',
        saveLWError: 'Please save Lien Waiver before generating Invoice',
        updateLWError: 'Please update Lien Waiver before generating Invoice',
        rejectInvoice: 'Reject Invoice',
        reject: 'Reject',
        invoice: 'Invoice',
        payments: 'Payments',
        WOIssued: 'WO Issued',
        addNewItem: 'Add New Item',
        WOOriginalAmount: 'WO Original Amount',
        expectedStartDate: 'Expected Start Date',
        expectedStart: 'Expected Start',
        expectedCompletionDate: 'Expected Completion Date',
        expectedCompletion: 'Expected Completion',
        completedByVendor: 'Completed by Vendor',
        verifiedDate: 'Verified Date',
        assignedLineItems: 'Assigned Line Items',
        downloadPDF: 'Download as PDF',
        markCompleted: 'Mark All Completed',
        productName: 'Product Name',
        sku: 'SKU',
        location: 'Location',
        quantity: 'Qty',
        price: 'Price',
        images: 'Images',
        invoicedDate: 'Invoiced Date',
        addSignature: 'Add Signature',
        typeName: 'Type Your Name Here',
        LWrequired: 'Lien Waiver is required for Draw Transaction.',
        AwardRq: 'You need to select award plan.',
        DrawRemaining: 'You have 0 Draw Remaining',
        MaterialRemaining: 'You have 0 Material Remaining',
        PaymentRemaining: 'Remaining payment amount exceeded.',
        nameofClaimant: 'Name of Claimant',
        customerName: 'Customer Name',
        jobLocation: 'Job Location',
        owner: 'Owner',
        makerOfCheck: 'Maker of check',
        amountOfCheck: 'Amount of Check $',
        checkPayableTo: 'Check Payable To',
        affectees: 'This document does not affect any of the following.',
        disputedClaims: 'Disputed claims for extras in the amount of: $',
        claimantsSignature: 'Claimant`s Signature',
        claimantsTitle: 'Claimant`s Title',
        dateOfSignature: 'Date Of Signature',
        apply: 'Apply',
        // Project-Lean-Weiver
        isUploadedSuccessfully: 'Is Uploaded Successfully',
        uploadLW: 'Upload LW',
        readMore: 'Read More',
        readLess: 'Read Less',
        recentLW: 'Recent LW',
        generatePDF: 'Generate PDF',
        generateLW: 'Generate LW',
        dateInvoiceSubmitted: 'Date Invoice Submitted',
        paymentTermDate: 'Payment Term Date',
        paymentDate: 'Payment Date',
        datePaymentProcessed: 'Date Payment Processed',
        expectedPayDate: 'Expected Pay Date',
        paymentTerms: 'Payment Terms',
        check: 'Check',
        paymentMethods: 'Payment Methods',
        payDateVariance: 'Pay Date Variance',
        finalInvoice: 'Final Invoice',
        finalApproved: 'Final Approved',
        uploadInvoice: 'Upload Invoice',
        firstHeading: 'Conditional waiver and release on final payment',
        secondHeading: 'Identifying Information',
        thirdHeading: 'Conditional Waiver and Release',
        fourthHeading: 'Exceptions',
        fifthHeading: 'Signature',
        noticeText:
          'NOTICE: This document waives the claimants lien, stop payment notice, and payment bond rights effective on receipt of payment. a person should not rely on this document unless satisfied that the claimant will/has received payment.',
        informationSection:
          'This document waives and releases lien, stop payment notice, and payment bond rights the claimant has for labor and service provided, and equipment and material delivered, to the customer on this job through the Through Date of this document. Rights based upon labor or service provided, or equipment or material delivered, pursuant to a written change order that has been fully executed by the parties prior to the date that this document is signed by the claimant, are waived and released by this document, unless listed as an Exception below. This document is effective only on the claimant`s schedule to receive or receipt of payment from the financial institution on which the following check is drawn:',
        // Projects-Documents
        document: 'Document',
        documentType: 'Document Type',
        fileType: 'File Type',
        vendorGL: 'Vendor',
        transactionDoc: 'Transaction',
        createdDate: 'Created Date',
        createdBy: 'Created By',
        uploadFile: 'Upload File',
        workOrderId: 'Work Order ID',
        // Project - Alerts
        value: 'Value',
        category: 'Category',
        dateTriggered: 'Date Triggered',
        // Project-Invoice
        invoiceNo: 'Invoice No.',
        PONumber: 'PO Number',
        invoiceDate: 'Invoice Date',
        dueDate: 'Due Date',
        recentINV: 'Recent INV',
        generateINV: 'Generate Invoice',
        generatePdf: 'Generate Pdf',
        item: 'Item',
        subTotal: 'Sub Total',
        totalAmountPaid: 'Total Amount Paid',
        balanceDue: 'Balance Due',
        see: 'See',
        // Project - Payments
        LWDate: 'LW Date',
        permitDate: 'Permit Date',
        paymentProcessed: 'Payment Processed',
        invoiceSubmitted: 'Invoice Submitted',
        expectedPay: 'Expected Pay Date',
        // Project - Notes
        notes: 'Notes',
        enterNewNote: 'Enter New Note Here',

        // VENDOR
        details: 'Details',
        market: 'Market',
        prjt: 'Projects',
        businessPhoneNumber: 'Business Phone Number',
        // Vendor-profile-details
        businessName: 'Business Name',
        score: 'Score',
        portalAccess: 'Portal Access',
        capacity: 'Capacity',
        last4digits: 'Last 4 digits of SSN/EIN',
        streetAddress: 'Street Address',
        state: 'State',
        secondaryPhoneNo: 'Secondary Phone No',
        city: 'City',
        sin: 'SSN',
        ein: 'EIN',
        zip: 'Zipcode',
        primaryContact: 'Primary Contact',
        secondaryContact: 'Secondary Contact',
        businessPhoneNo: 'Business Phone No',
        ext: 'Ext',
        secondaryNo: 'Secondary No',
        primaryEmail: 'Primary Email',
        businessEmail: 'Business Email',
        secondaryEmail: 'Secondary Email',
        coiglExpirationDate: 'COI-GL Expiration Date',
        constructionTrade: 'Construction Trade',
        totalCapacity: 'Total Capacity',
        activeDate: 'Active Date',
        statusLabel: 'Status',
        coiWcExpirationDate: 'COI-WC Expiration Date',
        einNumber: 'EIN/SSN',
        availableCapacity: 'Available Capacity',
        skills: 'Construction Trade',
        portalRegistration: 'Portal Registration',
        enableVendorPortal: 'Enable Vendor Portal',
        verifyProjectDesc: 'Project verified by ',
        verifyProject: 'Project Verified',
        // Vendor-profile-documents
        agreementSignedDate: 'Document Signed',
        uploadAgreement: 'Upload Agreement',
        downloadAgreementDocument: 'Download Agreement Document',
        W9DocumentDate: 'W9 Document',
        uploadW9Document: 'Upload W9 Document',
        downloadW9Document: 'Download W9 Document',
        documentsUpload: 'Documents Upload',
        autoInsuranceExpDate: 'Auto Insurance Expiry',
        uploadInsurance: 'Upload Insurance',
        downloadAutoInsuranceDocument: 'Download Auto Insurance Document',
        COIGLExpDate: 'COI GL Expiry',
        chooseFile: 'Choose File',
        viewFiles: 'View Files',
        downloadCOIGLDocument: 'Download COI GL Document',
        COIWCExpDate: 'COI WC Expiry',
        downloadCOIWCDocument: 'Download COI WC Document ',
        next: 'Next',
        back: 'Back',
        cancel: 'Cancel',
        insurances: 'Insurances',
        insurance: 'Insurance',
        W9Document: 'W9 Document',
        agreementSign: 'Agreement Sign',
        generalLiability: 'General Liability',
        workerComp: 'Worker Comp',

        // Vendor-profile-license
        license: 'License',
        addLicense: 'Add License',
        licenseType: 'License Type',
        licenseNumber: 'License Number',
        expiryDate: 'Expiry Date',
        fileInput: 'File Input',
        //Vendor-profile-Success
        updateLicenseDetails: 'Update Vendor Profile License',
        updateLicenseDetailsSuccess: 'Vendor profile license have been updated successfully.',
        updateDocumentDetails: 'Update Vendor Profile Document',
        updateDocumentDetailsSuccess: 'Vendor profile document have been updated successfully.',
        updateProfile: 'Update Vendor Profile Details',
        updateProfileSuccess: 'Vendor Profile Details have been updated successfully.',
        updateMarkets: 'Update Vendor Profile Market',
        updateMarketsSuccess: 'Vendor profile markets have been saved successfully.',
        updateTrades: 'Update Vendor Profile Trades',
        updateTradesSuccess: 'Vendor profile trades have been saved successfully.',
        createVendorSuccess: 'Vendor has been created successfully.',

        // Settings Page
        settings: 'Settings',
        firstName: 'First Name',
        lastName: 'Last Name',
        language: 'Language',
        profilePicture: 'Profile Picture',
        changePicture: 'Change your Profile Picture',

        // Password Page
        password: 'Password',
        currentPassword: 'Current Password',
        newPassword: 'New Password',
        newPasswordConfirmation: 'New Password Confirmation',
        passwordStrength: 'Password Strength',

        // Support Page
        createTicket: 'Create a Ticket',
        tickets: 'Tickets',
        issueType: 'Issue Type',
        severity: 'Severity',
        title: 'Title',
        descriptions: 'Description (1000 Characters)',
        fileUpload: 'File Upload',
        createTicketTitle: 'Create Ticket',
        createTicketSuccessMessage: 'Ticket created successfully.',
        createTicketErrorMessage: 'Create ticket api cause some error.',
        // Header
        help: 'Help',
        support: 'Support',
        signOut: 'Sign Out',
        // Project details
        originalSowAmount: 'Original SOW Amount',
        finalSowAmount: ' Final SOW Amount',

        paymentsTerms: 'Payments terms',
        woaExpectedPay: 'WOA Expected Pay',
        woaInvoiceDate: 'WOA Invoice Date',

        downloadOriginalSow: 'Download Original SOW',
        overpayment: 'Overpayment',
        remainingPayment: 'Remaining Payment',
        payment: 'Payment',
        invoiceBackDate: 'Invoice Back Date',

        // work order details
        cancelWorkOrder: 'Cancel Work Order',
        vendorName: 'Vendor Name',
        vendorType: 'Vendor Type',
        phoneNo: 'Phone No',
        woIssued: 'WO Issued',
        lwSubmitted: 'LW Submitted',
        permittedPulled: 'Permitted Pulled',
        completionVariance: 'Completion Variance',
        // Payments tab pc
        lwDate: 'LW Date',
        invoicedSubmitted: 'Invoiced Submitted',
        woOriginalAmount: 'WO Original Amount',
        clientOriginalAmount: 'Client Original Amount',
        clientFinalApprovedAmount: 'Client Final Approved Amount',

        // Alerts
        triggeredAlert: 'Triggered Alert',
        managedAlert: 'Managed Alert',
        resolveAll: 'Resolve All',
        projectId: 'Project Id',
        stateZipcode: 'State/Zipcode',
        workOrderStart: 'Work Order Start',
        woCompletionDate: 'Wo Completion Date',
        resolved: 'Resolved',
        resolve: 'Resolve',
        seeDetails: 'See Details',
        seeProjectDetails: 'See Project Details',
        seePropertyDetails: 'See Property Details',
        notify: 'Notify',
        alertingRules: 'Alerting Rules',
        attribute: 'Attribute',
        behaviour: 'Behaviour',
        customValue: 'Custom Value',
        userTypes: 'User Types',
        emailUser: 'Email User',
        recipient: 'Recipient',
        subject: 'Subject',
        body: 'Body',
        textUser: 'Text User',
        recipientPhoneNo: 'Recipient Phone No',
        WoId: 'WO Id',
        // **** PROJECT COORDINATOR ****//

        // PC projectDetails
        projectCoordinator: 'Project Coordinator',
        fieldProjectManager: 'Field Project Manager',
        superName: 'Super Name',
        superPhone: 'Super Phone',
        superEmail: 'Super Email',
        woaStartDateMessage:
          'WOA Start date is required to move the project to Active state, Please contact your PC or admin to provide WOA start date.',

        // PC Projects Table
        woNumber: 'WO Number',
        poNumber: 'PO Number',
        profitTotal: 'Profit Total',
        partialPayment: 'Partial Payment',
        partialPaymentDate: 'Partial Payment Date',
        woaCompletionDate: 'WOA Completion Date',
        accountPayable: 'Account Payable',
        accountRecievable: 'Account Recievable',
        woaPaidDate: 'WOA Paid Date',
        projectRelatedCost: 'Project Related Cost',
        invoiceNumber: 'Invoice Number',
        sowOriginalContractAmount: 'SOW Original Contract Amount',
        clientName: 'Client Name',
        zipCode: 'Zip Code',
        projectTypeLabel: 'Location',
        disqualifiedRevenueFlag: 'Disqualified Revenue',

        // PC Clients
        clientOverview: 'Client Overview',
        // businessName: 'Business Name',
        // accountPayable: 'Account Payable',
        paymentMethod: 'Payment Method',
        accPayConInfo: 'Accounts Payable contact details',
        creditCard: 'Credit Card',
        ach: 'ACH',
        comment: 'Comment',

        //Reports
        rptPageTitle: 'Reports',
        rptBackBtnLabel: 'Back',

        //Notifications
        viewAllNotification: 'View All Notifications',
      },
    },
    es: {
      translation: {
        //GLOBAL ERRORS
        EXPECTED_AND_COMPLETION_1_YEAR_ERROR:
          'La fecha de finalización esperada no puede ser más de 1 año de la fecha de inicio esperada',
        ...new_property.es.translation,
        ...vendorProjects.es.translation,
        ...transactionDetailI18n.es.tranlation,
        ...vendor_manager.es.translation,
        ...workOrder.es.translation,
        ...transaction.es.translation,
        ...projects.es.translation,
        ...userManagementTranslation.es.translation,
        ...project.es.translation,
        ...fpmCards.es.translation,
        ...clients.es.translation,
        ...accounts.es.translation,
        ...sideNav.es.translation,
        ...dashboard.es.translation,
        ...adminDashboard.es.translation,
        ...projectType.es.translation,
        ...auditLogs.es.translation,
        ...support.es.translation,
        ...vendorProfile.es.translation,
        ...projectAwards.es.translation,
        ...globalErrors.es.translation,
        ...performance.es.translation,

        ...property.es.translation,

        ...estimate.es.translation,

        //PC projectDetails
        projectCoordinator: 'Coordinador del proyecto',
        fieldProjectManager: 'Gerente de Proyectos de Campo',
        superName: 'Súper Nombre',
        superPhone: 'Súper Teléfono',
        superEmail: 'Súper correo electrónico',
        // Alerts
        triggeredAlert: 'Alerta activada',
        managedAlert: 'Alerta gestionada',
        resolveAll: 'Solucionelo todo',
        projectId: 'Projecto ID',
        stateZipcode: 'Estado/Código postal',
        workOrderStart: 'Inicio de orden de trabajo',
        woCompletionDate: 'Fecha de finalización de Wo',
        resolve: 'Resolver',
        resolved: 'Resuelta',
        seeDetails: 'Ver detalles',
        seeProjectDetails: 'Ver detalles del proyecto',
        seePropertyDetails: 'Ver detalles de la propiedad',
        notify: 'Notificar',
        alertingRules: 'Reglas de alerta',
        attribute: 'Atributo',
        behaviour: 'Comportamiento',
        customValue: 'Valor personalizado',
        userTypes: 'Tipos de usuarios',
        emailUser: 'Usuario de correo electrónico',
        recipient: 'Destinataria',
        subject: 'Sujeta',
        body: 'Cuerpo',
        textUser: 'Usuario de texto',
        recipientPhoneNo: 'Número de teléfono del destinatario',
        WoId: 'WO Id',

        // Payments tab pc
        lwDate: 'Fecha LW',
        invoicedSubmitted: 'Facturada enviada',
        paymentTerms: 'Términos de pago',
        woOriginalAmount: 'Importe original de la OT',
        clientOriginalAmount: 'Importe original del cliente',
        clientFinalApprovedAmount: 'Cantidad final aprobada por el cliente',

        // Work order details
        vendorName: 'nombre del vendedor',
        vendorType: 'tipo de vendedor',
        phoneNo: 'Telefono no',
        woIssued: 'WO emitido',
        lwSubmitted: 'LW Submitted',
        permittedPulled: 'Permitido tirado',
        completionVariance: 'Variación de finalización',
        cancelWorkOrder: 'Cancelar orden de trabajo',
        // Project details
        originalSowAmount: 'Importe de la SOW original',
        finalSowAmount: 'Importe de la SOW final',
        paymentsTerms: 'Condiciones de pago',
        woaExpectedPay: 'Pago esperado de WOA',
        downloadOriginalSow: 'Descargar SOW original',
        overpayment: 'Sobrepago',
        remainingPayment: 'pago restante',
        payment: 'Pago',
        invoiceBackDate: 'Reembolso de factura',
        // DASHBOARD
        vendorScore: 'Puntaje de Proveedor',
        vendorStatus: 'Estado del proveedor',
        upcomingPayment: 'Próximo pago',
        outOf: 'fuera de',
        insuranceExpiration: 'Vencimiento del Seguro',
        licenseExpiration: 'Caducidad de la licencia',
        agreementSigned: 'Acuerdo firmado',
        autoInsurance: 'Seguro de auto',
        errorWarning: 'No tienes ninguno',
        projectSummary: 'Resumen del Proyecto',
        activeWO: 'WO Activo',
        pastDue: 'Vencido',
        completedInvoiced: 'Facturado WO',
        projectManager: 'FPM',
        generalLabourName: 'Trabajo general',
        projectStatus: 'Estado',
        clientStartDate: 'Fecha de inicio del cliente',
        clientDueDate: 'Fecha de vencimiento del cliente',
        invoicedWO: 'Facturado WO',
        completednotPaid: 'Facturas rechazadas',
        upcomingPayments: 'Próximos Pagos',
        WOstatusGraph: 'Gráfico de Estado de WO',
        overview: 'INFORMACIÓN GENERAL',
        WOpaid: 'WO Pagado',
        paid: 'Pagado',
        active: 'Activa',
        paidSmall: 'Pagado',
        January: 'Enero',
        Februray: 'Febrero',
        March: 'Marzo',
        April: 'Abril',
        May: 'Mayo',
        June: 'Junio',
        July: 'Julio',
        August: 'Agosto',
        September: 'Septiembre',
        October: 'Octubre',
        November: 'Noviembre',
        December: 'Diciembre',
        export: 'Exportar',
        setting: 'Ajuste',
        electrical: 'Eléctrico',
        plumbing: 'Plomería',
        generalContractor: 'Contratista general',
        roofing: 'Techumbre',
        architecture: 'Arquitectura',
        mechanical: 'Mecánico',
        noDataDisplayed: 'No se han devuelto datos para esta vista.',

        // PROJECTS
        projectsHeading: 'Proyectos',
        columnSettings: 'Configuración de Columna',
        completed: 'Terminado',
        pendingTransaction: 'Transacción Pendiente',
        pastDueWO: 'Atrasado WO',
        type: 'Escribe',
        WOstatus: 'Estado WO',
        address: 'Habla a',
        region: 'Región',
        pendingTransactions: 'Transacciones Pendientes',
        expectedPaymentDate: 'Fecha de Pago Esperada',
        generalLabor: 'Trabajo general',
        materialCost: 'Costo material',
        drawAmount: 'Monto del sorteo',
        flag: 'Bandera',

        // receivable
        dueProjects: 'Proyectos Vencidos',
        client: 'Cliente',
        terms: 'Términos',
        paymentTypes: 'Formas De Pago',
        ticketStatus: 'Ticket Status',
        balance: 'Balance',

        woInvoiceDate: 'Fecha de factura de OT',
        poNo: 'Número de orden de compra',
        woNo: 'OT No',
        marketName: 'Mercados',
        checkbox: 'Caja',
        clearFilter: 'Filtro claro',

        // Payable
        propertyAddress: 'Dirección de Propiedad',
        managerSpecialistName: 'Especialista en mantenimiento',
        vendorAddress: 'Dirección del proveedor',
        wOCompletedDate: 'Fecha de finalización de la OT',
        wOIssueDate: 'Fecha de emisión de OT',
        id: 'IDENTIFICACIÓN',
        woStartDate: 'DOS Fecha de inicio',

        //  Projects - Table Setting Columns
        ProjectLabel: 'Escribe',
        vendorWOStatusValue: 'Estado WO',
        transactionTypeLabel: 'Escribe',
        parentWorkOrderId: 'Vendedora',
        transactionTotal: 'Cantidad Total',
        modifiedDate: 'Entregar',

        skillName: 'Comercio',
        pastDueWorkorders: 'Vencido WO',
        vendorWOExpectedPaymentDate: 'Fecha de Pago Esperada',

        // Project-Details
        status: 'Estado',
        newVendor: 'Nuevo Vendedor',
        vendorDetail: 'Detalle del proveedor',
        transactionStatus: 'Estado de la Transacción',
        //Project-Management tab
        woaStartDateMessage:
          'Se requiere la fecha de inicio de WOA para mover el proyecto al estado Activo. Comuníquese con su PC o administrador para proporcionar WOA fecha de inicio.',

        // Project - Transactions
        updateTransaction: 'Actualizar transacción',
        newTransaction: 'Nueva Transacción',
        newWorkOrder: 'Nueva Orden de Trabajo',
        newDocument: 'Nuevo Documento',
        newAlert: 'Nueva Alerta',
        editAlert: 'Editar Alerta',
        transaction: 'Transacción',
        vendorWorkOrders: 'Órdenes de Trabajo del Proveedor',
        documents: 'Documentos',
        alerts: 'Alertas',
        upload: 'Subir',
        uploadDocument: 'Subir documento',
        contactName: 'Nombre de Contacto',
        projectID: 'Projecto ID',
        WoID: 'WO ID',
        contactNo: 'Número de Contacto',
        WODueDate: 'Fecha de vencimiento de OT',
        dueDateWO: 'Fecha de vencimiento OT',
        trade: 'Comercio',
        auditLogs: 'Registros de auditoría',
        totalAmount: 'Cantidad Total',
        submit: 'Entregar',
        approvedBy: 'Aprobado Por',
        paymentType: 'Tipo de Pago',
        transactionType: 'Tipo de transacción',
        against: 'Estatuto',
        changeOrder: 'Cambia el Orden',
        workOrder: 'Orden de Trabajo',
        paymentTerm: 'Plazo de Pago',
        newExpectedCompletionDate: 'Nueva Fecha de Finalización Prevista',
        paymentReceivedDate: 'Pago Recibido',
        invoicedDate: 'Fecha Facturada',
        paidDate: 'Fecha de Pago',
        paidDateVariance: 'Variación de La Fecha de Pago',
        addNewRow: 'Añadir Nueva Fila',
        newRow: 'Fila nueva',
        rejectedInvoiceInfo: 'Información de factura rechazada',
        invoiceGenerateMsg: 'Estás segura de que quieres generar factura?',
        deleteRow: 'Borrar Fila',
        attachment: 'Adjunto Archivo',
        dateCreated: 'Fecha de Creacion',
        contact: 'Contacto',
        dateModified: 'Fecha Modificada',
        modifiedBy: 'Modificado Por',
        description: 'Descripción',
        amount: 'Monto',
        total: 'Total',
        close: 'Cerca',
        save: 'Ahorrar',

        // Project - WorkOrderDetails
        editVendorWorkOrder: 'Editar Orden de Trabajo de Proveedor',
        workOrderDetails: 'Detalles de la Orden de Trabajo',
        projectAward: 'Premio Proyecto',
        companyName: 'Nombre de empresa',
        ownerName: 'Contacto Primario',
        clientApprovedAmount: 'Monto aprobado por el cliente',
        profitPercentage: 'Porcentaje de beneficio',
        vendorWorkOrderAmount: 'Importe de la orden de trabajo del proveedor',
        name: 'Nombre',
        email: 'Correo electrónico',
        phone: 'Teléfono',
        issue: 'Asunto',
        rejectLienWaiver: 'Rechazar exención de gravamen',
        saveLWError: 'Guarde la exención de gravamen antes de generar la factura',
        updateLWError: 'Actualice la exención de gravamen antes de generar la factura',
        rejectInvoice: 'Rechazar Factura',
        lienWaiver: 'Exención de gravamen',
        estimates: 'Estimadas',
        lienWaiverRejectInfo: 'realizó cambios, necesita generar LW nuevamente.',
        invoice: 'Factura',
        payments: 'Pagos',
        WOIssued: 'Emitido WO',
        addNewItem: 'Agregar ítem nuevo',
        reject: 'Rechazar',
        WOOriginalAmount: 'Cantidad Original WO',
        expectedStartDate: 'Fecha de Inicio Esperada',
        expectedStart: 'Inicio esperado',
        expectedCompletionDate: 'Fecha de Finalización Prevista',
        expectedCompletion: 'Finalización Prevista',
        completedByVendor: 'Completado por el vendedor',
        verifiedDate: 'Fecha verificada',
        assignedLineItems: 'Elementos de línea asignados',
        downloadPDF: 'Descargar como PDF',
        markCompleted: 'Marcar todo completado',
        productName: 'Nombre del producto',
        sku: 'SKU',
        location: 'Ubicación',
        quantity: 'Cantidad',
        price: 'Precio',
        images: 'Imágenes',
        addSignature: 'Agregar Firma',
        typeName: 'Escribe tu nombre aquí',
        LWrequired: 'Se requiere exención de gravamen para la transacción de giro.',
        AwardRq: 'Debe seleccionar el plan de premios.',
        DrawRemaining: 'Tienes 0 sorteos restantes.',
        MaterialRemaining: 'Tienes 0 Material Restante.',
        PaymentRemaining: 'Monto de pago restante excedido.',
        nameofClaimant: 'Nombre del Reclamante',
        customerName: 'Nombre del Cliente',
        jobLocation: 'Locación de Trabajo',
        owner: 'Dueño',
        makerOfCheck: 'Fabricante de Cheques',
        amountOfCheck: 'Monto del cheque $ ',
        checkPayableTo: 'Cheque a Nombre de',
        affectees: 'Este documento no afecta a ninguno de los siguientes.',
        disputedClaims: 'Reclamaciones en disputa por extras por la cantidad de: $ ',
        claimantsSignature: 'Firma del Reclamante',
        claimantsTitle: 'Título del reclamante',
        dateOfSignature: 'Fecha de la Firma',
        apply: 'Aplicar',
        woaInvoiceDate: 'woa Factura Fecha',
        // Project - Lean-Weiver
        isUploadedSuccessfully: 'Se carga con éxito',
        uploadLW: 'Subir LW',
        readMore: 'Lee mas',
        readLess: 'Leer menos',
        recentLW: 'LW reciente',
        generatePDF: 'Generar PDF',
        generateLW: 'Generar LW',
        dateInvoiceSubmitted: 'Fecha de Envío de la Factura',
        paymentTermDate: 'Plazo de Pago Fecha',
        paymentDate: 'Fecha de pago',
        datePaymentProcessed: 'Fecha de Procesamiento del Pago',
        expectedPayDate: 'Fecha de Pago Esperada',
        check: 'Controlar',
        payDateVariance: 'Variación de la fecha de pago',
        finalInvoice: 'Factura Final',
        finalApproved: 'Aprobado definitivo',
        uploadInvoice: 'Cargar factura',
        firstHeading: 'Renuncia condicional y liberación en el pago final',
        secondHeading: 'Información identificativa',
        thirdHeading: 'Renuncia y Liberación Condicional',
        fourthHeading: 'Excepciones',
        fifthHeading: 'Firma',
        noticeText:
          'AVISO: Este documento renuncia a los derechos de gravamen, aviso de suspensión de pago y fianza de pago del reclamante a partir de la recepción del pago. una persona no debe confiar en este documento a menos que esté convencido de que el reclamante recibirá/ha recibido el pago.',
        informationSection:
          'Este documento renuncia y libera el gravamen, el aviso de suspensión de pago y los derechos de fianza de pago que tiene el reclamante por la mano de obra y el servicio prestados, y el equipo y el material entregados al cliente en este trabajo hasta la fecha de finalización de este documento. Los derechos basados ​​en la mano de obra o el servicio proporcionado, o el equipo o el material entregado, de conformidad con una orden de cambio por escrito que haya sido completamente ejecutada por las partes antes de la fecha en que el reclamante firme este documento, se renuncian y se liberan mediante este documento, a menos que enumerados como una excepción a continuación. Este documento es efectivo solo en el cronograma del reclamante para recibir o recibir el pago de la institución financiera contra la cual se gira el siguiente cheque:',
        // Projects - Documents
        document: 'Documento',
        documentType: 'Tipo de Documento',
        fileType: 'Tipo de Archivo',
        vendorGL: 'Vendedor',
        transactionDoc: 'Transacción',
        createdDate: 'Fecha de creación',
        createdBy: 'Creado por',
        uploadFile: 'Subir archivo',
        workOrderId: 'ID de pedido de trabajo',
        // Project - Alerts
        value: 'Valor',
        category: 'Categoría',
        dateTriggered: 'Fecha de activación',
        // Project-Invoice
        invoiceNo: 'Número de factura',
        PONumber: 'Numero postal',
        invoiceDate: 'Fecha de la factura',
        dueDate: 'Fecha de vencimiento',
        recentINV: 'Reciente INV',
        generateINV: 'Generar factura',
        generatePdf: 'Generate Pdf',
        item: 'Articulo',
        subTotal: 'Total parcial',
        totalAmountPaid: 'Cantidad total pagada',
        balanceDue: 'Saldo adeudado',
        see: 'Ver',
        // Project - Payments
        LWDate: 'Fecha LW',
        permitDate: 'Fecha del permiso',
        paymentProcessed: 'Pago procesado',
        invoiceSubmitted: 'Factura enviada',
        expectedPay: 'Fecha de pago esperada',
        // Project - Notes
        notes: 'Notas',
        enterNewNote: 'Ingrese una nueva nota aquí',

        // VENDOR-PROFILE
        details: 'Detalles',
        market: 'Mercado',
        prjt: 'Proyectos',
        businessPhoneNumber: 'Número de teléfono laboral',

        // Vendor-profile-details
        businessName: 'Nombre del Negocio',
        score: 'Puntaje',
        portalAccess: 'Acceso al Portal',
        enableVendorPortal: 'Enable Vendor Portal',
        verifyProjectDesc: 'Proyecto verificado por',
        verifyProject: 'Proyecto Verificado',

        capacity: 'Capacidad',
        last4digits: 'Últimos 4 dígitos del SSN/EIN',
        paymentMethods: 'Métodos de Pago',
        streetAddress: 'Dirección',
        state: 'Expresar',
        secondaryPhoneNo: 'Número de teléfono secundario',
        city: 'Ciudad',
        sin: 'PECADO',
        ein: 'EIN',
        zip: 'Cremallera postal',
        primaryContact: 'Contacto Primario',
        secondaryContact: 'Contacto Secundario',
        businessPhoneNo: 'Número de teléfono de la empresa',
        ext: 'Extensión',
        secondaryNo: 'Número Secundario',
        primaryEmail: 'Correo Electrónico Principal',
        businessEmail: 'email de negocios',
        secondaryEmail: 'Email Secundario',
        coiglExpirationDate: 'Fecha de vencimiento de COI-GL',
        constructionTrade: 'Construcción Comercio',
        totalCapacity: 'Capacidad total',
        activeDate: 'Fecha Activa',
        statusLabel: 'Estado',
        coiWcExpirationDate: 'Fecha de vencimiento de COI-WC',
        einNumber: 'EIN/SSN',
        availableCapacity: 'Capacidad disponible',
        skills: 'Habilidades',

        // Vendor-profile-documents
        agreementSignedDate: 'Documento firmado',
        uploadAgreement: 'Acuerdo de Carga',
        downloadAgreementDocument: 'Descargar Documento de Acuerdo',
        W9DocumentDate: 'Documento W9',
        uploadW9Document: 'Cargar Documento W9',
        downloadW9Document: 'Descargar Documento W9',
        documentsUpload: 'Carga de Documentos',
        autoInsuranceExpDate: 'Vencimiento del seguro de automóvil',
        uploadInsurance: 'Subir Seguro',
        downloadAutoInsuranceDocument: 'Descargar Documento de Seguro de Automóvil',
        COIGLExpDate: 'Expiración COI GL',
        chooseFile: 'Elija el Archivo',
        viewFiles: 'Archivos de vista',
        downloadCOIGLDocument: 'Descargar Documento COI GL',
        COIWCExpDate: 'Expiración COI WC',
        downloadCOIWCDocument: 'Descargar Documento COI WC',
        next: 'Próximo',
        back: 'Espalda',
        cancel: 'Cancelar',
        insurances: 'Seguros',
        insurance: 'Seguro',
        W9Document: 'Documento W9',
        agreementSign: 'Signo de acuerdo',
        generalLiability: 'Responsabilidad general',
        workerComp: 'Compensación al trabajador',

        // Vendor-profile-license
        license: 'Licencia',
        addLicense: 'Agregar Licencia',
        licenseType: 'Tipo de Licencia',
        licenseNumber: 'Número de Licencia',
        expiryDate: 'Fecha de Caducidad',
        fileInput: 'Entrada de Archivo',
        //Vendor-profile-Success
        updateLicenseDetails: 'Actualizar licencia de perfil de proveedor',
        updateLicenseDetailsSuccess: 'La licencia de perfil de proveedor se ha actualizado correctamente.',
        updateDocumentDetails: 'Actualizar documento de perfil de proveedor',
        updateDocumentDetailsSuccess: 'El documento de perfil del proveedor se ha actualizado correctamente.',
        updateProfile: 'Actualizar los detalles del perfil del proveedor',
        updateProfileSuccess: 'Los detalles del perfil del proveedor se han actualizado correctamente.',
        updateMarkets: 'Actualizar mercados de perfiles de proveedores',
        updateMarketsSuccess: 'Los mercados de perfiles de proveedores se han guardado correctamente.',
        updateTrades: 'Actualizar intercambios de perfiles de proveedores',
        updateTradesSuccess: 'Las transacciones del perfil del proveedor se han guardado correctamente.',
        createVendorSuccess: 'El proveedor se ha creado correctamente.',

        // Settings Page
        settings: 'Ajustes',
        firstName: 'Primer Nombre',
        lastName: 'Apellido',
        language: 'Idioma',
        profilePicture: 'Foto de perfil',
        changePicture: 'Cambia tu foto de perfil',

        // Password Page
        password: 'Clave',
        currentPassword: 'Contraseña actual',
        newPassword: 'Nueva contraseña',
        newPasswordConfirmation: 'Nueva confirmación de contraseña',
        passwordStrength: 'Seguridad de la contraseña',

        // Support Page
        createTicket: 'Crear un boleto',
        issueType: 'Tipo de problema',
        severity: 'Gravedad',
        title: 'Título',
        descriptions: 'Descripción (1000 Caracteres)',
        fileUpload: 'Subir archivo',
        createTicketTitle: 'Crear Ticket',
        createTicketSuccessMessage: 'Ticket creado con éxito.',
        createTicketErrorMessage: 'Crear ticket api causa algún error.',

        // Header
        help: 'Ayudar',
        support: 'Apoyo',
        signOut: 'Desconectar',

        // **** PROJECT COORDINATOR ****//

        // PC Clients
        clientOverview: 'Descripción general del cliente',
        // businessName: 'Nombre del Negocio',
        accountPayable: 'Cuenta por pagar',
        paymentMethod: 'Método de pago',
        accPayConInfo: 'Datos de contacto de cuentas por pagar',
        creditCard: 'Crédito',
        ach: 'ACH',
        comment: 'Comentario',
        partialPayment: 'Pago parcial',
        partialPaymentDate: 'Fecha de pago parcial',

        // Alerts
        triggeredAlerts: 'Alertas activadas',
        managedAlerts: 'Alertas administradas',

        //Reports
        rptPageTitle: 'Informes',
        rptBackBtnLabel: 'atrás',

        //Notifications
        viewAllNotification: 'Ver todas las notificaciones',
      },
    },
  },
  lng: 'en',
  fallbackLng: 'en',
  react: {
    useSuspense: false,
  },
})

export default i18n
